/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListScheduledChangeSummaryData } from './genericApiResponseListScheduledChangeSummaryData';
import type { GenericApiResponseListScheduledChangeSummaryMessage } from './genericApiResponseListScheduledChangeSummaryMessage';
import type { GenericApiResponseListScheduledChangeSummaryPagination } from './genericApiResponseListScheduledChangeSummaryPagination';
import type { GenericApiResponseListScheduledChangeSummaryError } from './genericApiResponseListScheduledChangeSummaryError';

export interface GenericApiResponseListScheduledChangeSummary {
  data?: GenericApiResponseListScheduledChangeSummaryData;
  message?: GenericApiResponseListScheduledChangeSummaryMessage;
  pagination?: GenericApiResponseListScheduledChangeSummaryPagination;
  error?: GenericApiResponseListScheduledChangeSummaryError;
  statusCode?: number;
}
